//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PATTERNS_VALIDATION } from '@/js/constants';
import PaginationVue from '@/components/PaginationVue';
import { localPaginationMixin } from '@/mixins/local_pagination';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
export default {
  name: 'EditUsersReportComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    PaginationVue: PaginationVue
  },
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      DIALOG_CONFIRMATION: 'DIALOG_CONFIRMATION',
      itemEliminar: {
        applicant: null
      },
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      valid: false,
      newUser: '',
      tipoUsuario: null,
      reports: [],
      keyTable: 0,
      userToEdit: null,
      isEditMode: false,
      pagination: {
        current: 1,
        limit: 5,
        total: 0
      },
      search: '',
      isLoading: false
    };
  },
  created: function created() {
    this.getReportAssignments();
  },
  methods: {
    resetForm: function resetForm() {
      this.newUser = '';
      this.tipoUsuario = null;
      this.userToEdit = null;
      this.resetValidation();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onAssignUser: function onAssignUser(event) {
      var _this = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var params = {
        applicant: this.newUser,
        user_type: this.tipoUsuario
      };
      if (this.userToEdit) {
        // Actualiza el usuario existente
        Somos1Service.updateUserReport(this.item.document_id, params).then(function (response) {
          _this.resetForm();
          _this.userToEdit = null;
          _this.$toast.info('Usuario actualizado');
          _this.getReportAssignments();
        });
      } else {
        // Crea un nuevo usuario
        Somos1Service.assignUserReport(this.item.document_id, params).then(function (response) {
          _this.resetForm();
          _this.$toast.info('Usuario añadido');
          _this.getReportAssignments();
        });
      }
    },
    onRevokeUser: function onRevokeUser(item) {
      this.itemEliminar = item;
      console.log(item);
      this.openDialog(this.DIALOG_CONFIRMATION);
    },
    getReportAssignments: function getReportAssignments() {
      var _this2 = this;
      this.isLoading = true;
      var params = {
        filters: [{
          key: 'report_id',
          operator: '==',
          value: this.item.document_id
        }, {
          key: 'active',
          operator: '==',
          value: true
        }]
      };
      Somos1Service.getReportsAssignments(params).then(function (response) {
        _this2.isLoading = false;
        _this2.reports = response.data;
        _this2.keyTable += 1;
      });
    },
    ruleEmail: function ruleEmail(value) {
      var regexValidation = this.emailPattern.test(value);
      if (!regexValidation) {
        return this.translate('reglas.wrong_emails');
      }
      if (!this.userToEdit) {
        if (this.reports.findIndex(function (item) {
          return item.applicant === value;
        }) !== -1) {
          return this.translate('reglas.duplicate_email');
        }
      }
      return true;
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onSubmitConfirmation: function onSubmitConfirmation(valor) {
      var _this3 = this;
      if (valor) {
        Somos1Service.revokeUserReport(this.itemEliminar.document_id).then(function (response) {
          console.log(response);
          _this3.$toast.info('Usuario eliminado');
          _this3.getReportAssignments();
          _this3.resetForm();
        });
        this.$refs[this.DIALOG_CONFIRMATION].onClose();
      } else {
        this.$refs[this.DIALOG_CONFIRMATION].onClose();
      }
    },
    onEditUser: function onEditUser(item) {
      this.isEditMode = true;
      this.newUser = item.applicant;
      this.tipoUsuario = item.user_type;
      this.userToEdit = item;
    } // onNewUser() {
    //   this.isEditMode = false
    //   this.newUser = ''
    //   this.tipoUsuario = null
    //   this.userToEdit = null
    //   this.resetValidation()
    // }
  },
  computed: {
    headers: function headers() {
      return [{
        text: 'User',
        value: 'applicant'
      }, {
        text: 'Tipo de Usuario',
        value: 'user_type'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    rules: function rules() {
      var _this4 = this;
      return {
        email: [function (v) {
          return !!v || _this4.translate('reglas.field');
        }, this.ruleEmail],
        user_type: [function (v) {
          return !!v || _this4.translate('reglas.field');
        }]
      };
    },
    filteredItems: function filteredItems() {
      var _this5 = this;
      return this.reports.filter(function (item) {
        return item.applicant.toLowerCase().includes(_this5.search.toLowerCase());
      });
    }
  }
};